/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Telegram_Link_CtaInputs */

const he_account_delivery_telegram_link_cta = /** @type {(inputs: Account_Delivery_Telegram_Link_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חיבור טלגרם`)
};

const en_account_delivery_telegram_link_cta = /** @type {(inputs: Account_Delivery_Telegram_Link_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Telegram`)
};

/**
* | output |
* | --- |
* | "Link Telegram" |
*
* @param {Account_Delivery_Telegram_Link_CtaInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_telegram_link_cta = /** @type {((inputs?: Account_Delivery_Telegram_Link_CtaInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Telegram_Link_CtaInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_telegram_link_cta(inputs)
	return en_account_delivery_telegram_link_cta(inputs)
});